import { IconControl, ButtonControl } from "spark-core-dx/components"
import './DashMessage.scss'

export const DashMessage = ({ icon, title, description, onClick, buttonText, Svg, fill = true }) => (
    <div className="dashboard-message-full">
        {icon && <IconControl className={`big-icon ${fill ? 'fill' : ''}`} iconKey={icon} />}
        {Svg && <Svg />}
        <div className="dashboard-message-full-text">
            <div className="title-text">{title}</div>
            <div className="subtitle-text">{description}</div>
        </div>
        {(buttonText && onClick) && <ButtonControl onClick={onClick} value={buttonText} type={'okay'} />}
    </div>
)
